import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
    fallback?: ReactNode;
}

interface State {
    hasError: boolean;
}

/**
 * Chặn lỗi render của cây con để MỘT lỗi (vd require ảnh thiếu file, dữ liệu
 * server không đúng dạng) không làm trắng màn hình TOÀN BỘ app — gồm cả form
 * đăng nhập. Không có nó, mọi lỗi render đều gỡ toàn bộ cây React.
 */
class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        // Giữ log để còn debug; có thể thay bằng gửi về hệ thống giám sát.
        console.error('[ErrorBoundary]', error, info.componentStack);
    }

    handleReload = () => {
        this.setState({ hasError: false });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            if (this.props.fallback !== undefined) return this.props.fallback;
            return (
                <div
                    style={{
                        minHeight: '60vh',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 16,
                        padding: 24,
                        textAlign: 'center',
                        color: '#1a2340',
                    }}
                >
                    <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>Đã xảy ra lỗi hiển thị</h3>
                    <p style={{ margin: 0, color: '#6b7590', maxWidth: 360 }}>
                        Trang gặp sự cố khi tải. Vui lòng thử lại.
                    </p>
                    <button
                        type="button"
                        onClick={this.handleReload}
                        style={{
                            padding: '10px 20px',
                            borderRadius: 10,
                            border: 0,
                            background: 'linear-gradient(180deg, #1b53f0, #011e98)',
                            color: '#fff',
                            fontSize: 14,
                            fontWeight: 700,
                            cursor: 'pointer',
                        }}
                    >
                        Tải lại
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
